import getScenarioStore from '../selectors/getScenarioStore';
import { mutator } from 'satcheljs';
import { setSelectedPillIndex } from '../actions/internalActions';

export default mutator(setSelectedPillIndex, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).selectedPillIndex = actionMessage.selectedPillIndex;
});
